// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4946":"74bbedfb","9036":"d429e16f"}[chunkId] + ".chunk.css";
};